import React, {useState, useEffect} from "react";
import {useState as useAppState} from "../state/useState";
import {order} from "../service/RechargeService";
import {redirectTo} from "../state/action";
import {checkStatus} from "../service/RechargeService";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';


export function Status({history, uuid, status, voucherCode, email}) {


    function getStatus(status) {
        if (status == 6 || status == 7) {
            return "Uspješna"
        } else {
            return "Neuspješna"
        }
    }

    return <>
        <div class="page_title2">
            <div class="container">

                <div class="title"><h1>Obrada transakcije...</h1></div>
            </div>
        </div>


        <div class="clearfix"></div>

        <div class="container">

            <div class="content_fullwidth">

                <div class="reg_form">
                    <p><h3 class="nocaps">Transakcija je obradjena!</h3>
                    </p>
                    <blockquote><p>Transakcija: <strong>{uuid}</strong></p></blockquote>
                    <blockquote><p>Status: <strong>{getStatus(status)}</strong></p></blockquote>
                    {voucherCode && voucherCode != "undefined" && email && <blockquote>
                        <p>Kod za nadoplatu <strong>{voucherCode}</strong> smo Vam</p>
                        <p>poslali i na e-mail <strong>{email}</strong></p>
                        <p>Provjerite bezvrijednu poštu u slučaju da ga</p>
                        <p>ne možete pronaći.</p>
                    </blockquote>
                    }

                    <p></p>


                    <p></p>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div className="left"><a href="javascript:undefined" onClick={() => history.push("/")}
                                             className="knowmore_but"><i
                        className="fa fa-hand-o-left fa-lg"></i> NAZAD</a></div>

                </div>


            </div>

        </div>

        <div class="clearfix margin_top7">

        </div>

        <div class="clearfix"></div>

    </>

}
